
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class HolidayListDialog extends Serenity.EntityDialog<HolidayListRow, any> {
        protected getFormKey() { return HolidayListForm.formKey; }
        protected getIdProperty() { return HolidayListRow.idProperty; }
        protected getLocalTextPrefix() { return HolidayListRow.localTextPrefix; }
        protected getNameProperty() { return HolidayListRow.nameProperty; }
        protected getService() { return HolidayListService.baseUrl; }
        protected getDeletePermission() { return HolidayListRow.deletePermission; }
        protected getInsertPermission() { return HolidayListRow.insertPermission; }
        protected getUpdatePermission() { return HolidayListRow.updatePermission; }

        protected form = new HolidayListForm(this.idPrefix);

    }
}